import apiClient from './api_client_requests';

export default async payload => {
    console.log(payload.points);
    let result = await apiClient.apiMethod({
        method: 'SetEntryFlashGameFlag',
        args: {
            promotion: 'monopoly',
            flag: 2,
            game_id: '7332',
            entry_id: payload.entry_id,
        },
    });

    return result;
};
